import React, { Component } from 'react'

export default class MyCompetition extends Component {
    render() {
        return (
            <div>
                MyCompetition
            </div>
        )
    }
}
